export default function GS_Sort_Range() {
  return (
    <div className="p-4">
      <h1>GS Sort Range</h1>
    </div>
  );
}
